import PropTypes from "prop-types";
import React from "react";

import ReassignRestForm from "v2/components/responsive/ReassignRestForm";
import ModalLink from "v2/components/responsive/ModalLink";

const ReassignRestLink = (props, context) => {
  const {params: {date, routeId, id}} = context;
  return (
    <ModalLink
      form={ReassignRestForm}
      label="Reassign Rest"
      url={`/${date}/${routeId}/${id}/rest`}
      {...props} />
  );
};

ReassignRestLink.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }),
};

export default ReassignRestLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/ReassignRestLink.js
 **/